import { filter as _filter } from 'lodash';
import {
  GET_CLIENTS,
  GET_CLIENTS_SUCCESS,
  GET_CLIENT_SUCCESS,
  GET_CLIENT,
  ADD_CLIENT,
  UPDATE_CLIENT_SUCCESS,
  DELETE_CLIENT_SUCCESS,
  CREATE_CLIENT_SUCCESS,
  CLIENTS_ERROR,
  EDIT_CLIENT,
  CANCEL_UPDATE,
  SET_CLIENT,
  SET_SUBSCRIPTION,
  UPDATE_CLIENT_APPS,
  ADD_LOADING_CLIENT,
  REMOVE_LOADING_CLIENT,
  CLEAR_LOADING_CLIENT,
  UPDATE_USER_LIST,
  UPDATE_CLIENT_LIST,
  UPDATE_APPROLE_LIST,
  ADD_SUBSCRIPTION_CLIENT_SUCCESS,
  REMOVE_SUBSCRIPTION_CLIENT,
  REMOVE_SUBSCRIPTION_CLIENT_SUCCESS,
  ADD_SUBSCRIPTION_CLIENT,
  GET_CLIENT_AUDIT_LOGS,
  GET_CLIENT_AUDIT_LOGS_SUCCESS,
} from '../constants/action-types/clients';
import { initialStateClients } from '../store/models/clients';

export default function clientsReducer(state = initialStateClients, action) {
  switch (action.type) {
    case SET_CLIENT:
      return { ...state, cid: action.cid };
    case SET_SUBSCRIPTION:
      return { ...state, sub: action.sub };
    case UPDATE_CLIENT_APPS:
      return { ...state, apps: action.apps };
    case ADD_LOADING_CLIENT:
      return { ...state, loading: [...state.loading, action.action] };
    case REMOVE_LOADING_CLIENT:
      return { ...state, loading: state.loading.filter(load => load !== action.action) };
    case CLEAR_LOADING_CLIENT:
      return { ...state, loading: [] };
    case UPDATE_USER_LIST:
      return { ...state, users: action.users };
    case UPDATE_CLIENT_LIST:
      return { ...state, clients: action.clients };
    case UPDATE_APPROLE_LIST:
      return { ...state, approles: action.approles };
    case GET_CLIENTS:
      return {
        ...state,
        data: [],
        isLoading: true,
        isEditing: false,
      };
    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        data: action.data,
        isLoading: false,
      };
    case GET_CLIENT:
      return {
        ...state,
        selectedClient: {},
        isLoading: true,
      };
    case GET_CLIENT_SUCCESS:
      return {
        ...state,
        selectedClient: action.data,
        isLoading: false,
      };
    case ADD_CLIENT:
      return {
        ...state,
        selectedClient: {},
      };
    case CREATE_CLIENT_SUCCESS:
      return {
        ...state,
        data: state.data.concat([action.data]),
        selectedClient: action.data,
      };
    case UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        data: state.data.map(client => (client.id === action.data.id ? action.data : client)),
        selectedClient: action.data,
        isEditing: false,
      };
    case DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        isEditing: false,
        selectedClient: {},
        data: _filter(state.data, client => client.id !== action.id),
        isLoading: false,
      };
    case CLIENTS_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case EDIT_CLIENT:
      return {
        ...state,
        isEditing: true,
      };
    case CANCEL_UPDATE:
      return {
        ...state,
        isEditing: false,
      };
    case ADD_SUBSCRIPTION_CLIENT:
      return {
        ...state,
        isLoading: true,
        data: action.tier,
      };
    case ADD_SUBSCRIPTION_CLIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case REMOVE_SUBSCRIPTION_CLIENT:
      return {
        ...state,
        isLoading: true,
      };
    case REMOVE_SUBSCRIPTION_CLIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case GET_CLIENT_AUDIT_LOGS:
      return {
        ...state,
        isLoading: true,
      };
    case GET_CLIENT_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        auditLogs: action.data,
        isLoading: false,
      };
    default:
      return state;
  }
}
